import React from 'react'
import { Drawer } from 'antd'
import './index.scss'

const PaymentConfirmationModal = ({ isOpen, onCancel, link, className }) => {
  return (
    <Drawer placement="bottom" onClose={onCancel} open={isOpen} className={`PaymentConfirmationModal ${className || ''}`}>
      {link && <iframe src={link} title="" width="100%" height="100%" />}
    </Drawer>
  )
}

export default PaymentConfirmationModal
